/**
 * Gravitee.io Portal Rest API
 * API dedicated to the devportal part of Gravitee
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: contact@graviteesource.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Token { 
    token_type?: Token.TokenTypeEnum;
    token?: string;
}
export namespace Token {
    export type TokenTypeEnum = 'BEARER';
    export const TokenTypeEnum = {
        BEARER: 'BEARER' as TokenTypeEnum
    };
}


